/** 铃铛要处理的统一计数：未读需处理动态 + 未处理运维告警。两套类型分开计，不互相顶替。 */
export function notificationHandleCount(requiresAction: number, openAlerts: number): number {
  const action = Number.isFinite(requiresAction) && requiresAction > 0 ? requiresAction : 0
  const alerts = Number.isFinite(openAlerts) && openAlerts > 0 ? openAlerts : 0
  return action + alerts
}
